module.exports = __webpack_public_path__ + "hero3.png?047057dc0771172e1e9a6f155f00ed1d";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/hero3.png
// module id = 336
// module chunks = 0